export { default } from './Thumbnail'
export type { ThumbnailSrc } from './Thumbnail'
